
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.css']
})
export class TaxComponent implements OnInit {

  acctList = [];
  acctDetail = '';

  model = {
    'table_name': 'tax', 'tax_id': '0', 'acct_number': '', 'tax_name_ar': '', 'tax_name_en': '', 
    'tax_perc': '', 'tax_amount': '', 'key': 'tax_id', 'flag': 'new', 'comment': ''
  };

  date_model = { 'base_date': new Date(this.applicationConstants.business_cycle.start_date), 
    'base_type': 'creditor' };
  
  sub_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0', 
    'acct_type_no': this.applicationConstants.acct_type_config['tax'], 
    'main_acct_no': this.applicationConstants.main_acct_config['tax'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': '', 'acct_level': '0', 'is_leaf': '1', 
    'is_cc': '1', 'cc_no': '0', 'key': 'sub_acct_id', 'flag': 'new', 
    'deletable': '1'
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '', 
    'main_acct_no': this.applicationConstants.main_acct_config['tax'], 
    'acct_type_no': this.applicationConstants.acct_type_config['tax'],
    'key': 'baseline_id', 'flag': 'new', 'baseline_amount': '0'
  };

  Success_Msg; Error_Msg; Tax_Name_Msg; Per_Msg; 
  Acct_No_Exist; Belong_To_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<TaxComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Tax_Name_Msg').subscribe((res: string) => {
      this.Tax_Name_Msg = res;
    });

    translate.get('Per_Msg').subscribe((res: string) => {
      this.Per_Msg = res;
    });
    
    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });
    
    translate.get('Belong_To_Msg').subscribe((res: string) => {
      this.Belong_To_Msg = res;
    });
  }

  ngOnInit() {
    let obj;

    // get not leaf tax accts
    let parent_acct = this.applicationConstants.main_acct_config['tax'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, include_parent: true, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctList = data.data['list'];

        if (this.dialog_data == null) {
          if (this.acctList.length > 0) {
            parent_acct = this.acctList[0]['acct_number'];
            this.acctDetail = parent_acct + ' - ' + this.acctList[0]['sub_acct_name'] + ' - ' + 
              this.acctList[0]['sub_acct_name_en'];
          }
          else 
            this.acctDetail = parent_acct + ' - حسابات الضريبة - Tax Accounts';

          this.onChangeAcctSearch("", parent_acct);
        }
      });

    if (this.dialog_data != null) {
      this.model = this.dialog_data;

      // get sub acct
      let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            let sub_acct = data.data['list'][0];
            this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
            this.sub_acct_model['acct_number'] = sub_acct['acct_number'];
            this.sub_acct_model['sub_acct_name'] = sub_acct['sub_acct_name'];
            this.sub_acct_model['sub_acct_name_en'] = sub_acct['sub_acct_name_en'];
            this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
            this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
            this.sub_acct_model['is_leaf'] = sub_acct['is_leaf'];
            this.sub_acct_model['is_cc'] = sub_acct['is_cc'];
            this.sub_acct_model['flag'] = 'update';

            // get parent acct detail
            query = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let parent_acct = data.data['list'][0];
                this.acctDetail = sub_acct['parent_acct'] + ' - ' +  parent_acct['sub_acct_name'] + ' - ' + 
                  parent_acct['sub_acct_name_en'];
              });
          }
        });
    }
  }

  onChangeAcctSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.sub_acct_model['parent_acct'] = "";
      this.sub_acct_model['acct_level'] = "0";

      if (acct_number != '')
        this.sub_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '') 
        this.sub_acct_model['parent_acct'] = parent_acct;

      // if (this.sub_acct_model['parent_acct'] != "") {
      var element;
      for (let index = 0; index < this.acctList.length; index++) {
        element = this.acctList[index];
        if (element.acct_number == this.sub_acct_model['parent_acct']) {
          this.sub_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
          break;
        }
      }
      if (this.sub_acct_model['acct_level'] == "0") 
        this.sub_acct_model['acct_level'] = String(Number(this.sub_acct_model['acct_level']) + 1);

      if (this.model['tax_id'] == '0') {
        this.model['acct_number'] = "";
        
        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" + 
          this.sub_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };
        
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            
            let result = Number(data.data['list'][0]['acct_number']);
            if (result == 0) 
              this.model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
            else
              this.model['acct_number'] = String(result + 1);
          });
        // }
      }
      
    }
  }

  changeAcctNumber() {
    if (this.model['acct_number'] == "" && this.sub_acct_model['parent_acct'] != "")
      this.onChangeAcctSearch("", this.sub_acct_model['parent_acct']);
  }

  add() {
    if (this.model['tax_name_ar'] == '') {
      alert(this.Tax_Name_Msg);
      (document.getElementById('tax_name_ar') as HTMLInputElement).focus();
      return;
    }
    // else if (this.model['tax_name_en'] == '') {
    //   alert("الرجاء إدخال الاسم الانجليزي");
    //   (document.getElementById('tax_name_en') as HTMLInputElement).focus();
    // }

    if (this.model['tax_perc'] == '' && this.model['tax_amount'] == '') {
      alert(this.Per_Msg);
      (document.getElementById('tax_perc') as HTMLInputElement).focus();
      return;
    }

    if (this.sub_acct_model['parent_acct'] == '') {
      alert(this.Belong_To_Msg);
      return;
    }
    
    if (this.model['tax_perc'] == '') this.model['tax_perc'] = '0';
    if (this.model['tax_amount'] == '') this.model['tax_amount'] = '0';

    let values = [];
    let obj;

    if (this.model['tax_id'] == '0') {
      
      values.push(this.model);

      let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          
          let result = data.data['list'];
          if (result.length > 0) 
            alert(this.Acct_No_Exist);  
          else {
            // add tax account
            this.sub_acct_model['acct_number'] = this.model['acct_number'];
            this.sub_acct_model['sub_acct_name'] = this.model['tax_name_ar'];
            this.sub_acct_model['sub_acct_name_en'] = this.model['tax_name_en'];
            values.push(this.sub_acct_model);

            // add tax base
            this.base_model['base_date'] = this.date_model['base_date'].getFullYear() + '-' +
              (this.date_model['base_date'].getMonth() + 1) + '-' + this.date_model['base_date'].getDate() +
              ' 00:00:00';

            if (this.date_model['base_type'] == 'creditor' && this.base_model['baseline_amount'] != '0')
              this.base_model['baseline_amount'] = '-' + this.base_model['baseline_amount'];

            this.base_model['acct_number'] = this.model['acct_number'];
            values.push(this.base_model);

            obj = { cmd: 'add', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.dialog_data = { 'op_type': 'success' };
                  this.dialogRef.close(this.dialog_data);
                }
                else
                  alert(this.Error_Msg);

              });
          }
        });
    }
    else {
      values.push(this.model);

      this.sub_acct_model['acct_number'] = this.model['acct_number'];
      this.sub_acct_model['sub_acct_name'] = this.model['tax_name_ar'];
      this.sub_acct_model['sub_acct_name_en'] = this.model['tax_name_en'];
      values.push(this.sub_acct_model);

      if (this.sub_acct_model['sub_acct_id'] == '0') {
        // add tax base
        this.base_model['base_date'] = this.date_model['base_date'].getFullYear() + '-' +
          (this.date_model['base_date'].getMonth() + 1) + '-' + this.date_model['base_date'].getDate() +
          ' 00:00:00';

        if (this.date_model['base_type'] == 'creditor' && this.base_model['baseline_amount'] != '0')
          this.base_model['baseline_amount'] = '-' + this.base_model['baseline_amount'];

        this.base_model['acct_number'] = this.model['acct_number'];
        values.push(this.base_model);
      }

      obj = { cmd: 'updateAdv', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else
            alert(this.Error_Msg);

        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
